/*
 * Consent text + version shown to operators in the dashboard's consent notice
 * for the AI capture modes.
 *
 * VERBATIM copy of the owner-approved release text guests see on the iPad
 * (card mb-ai-consent-release-screen, pick 1A, 2026-10-30). Authoritative
 * homes: rails `ConsentRecord::BIPA_CONSENT_TEXT_VERSION` /
 * `BIPA_CONSENT_TEXTS` (app/models/consent_record.rb) and iOS
 * `AIConsentText` (Movebooth2/AIConsent.swift). Change no character without a
 * new owner OK and a new version id on rails + iOS + here. React only
 * displays this; it never sends the version to rails.
 */

export const BIPA_CONSENT_TEXT_VERSION = "2026-10-29.ai-release-2";

export const BIPA_CONSENT_TEXT = [
  "Your AI photo uses your face",
  "Movebooth and our AI providers process the photos we take next, including your face geometry (the shape of your face and where your features sit), only to make your AI photo. Some laws call this biometric data. Our AI providers include the makers of the AI models they use and the companies that host the providers' systems.",
  "We delete these photos 30 days after we deliver your AI photo. 18+ only. Withdraw anytime at pip@movebooth.com.",
  "Learn more",
  "Type your full name to sign",
  "No thanks",
  "I agree",
].join("\n\n");
